module.exports = __webpack_public_path__ + "mstile-70x70.png";